module.exports = __webpack_public_path__ + "static/img/a616.8582a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a616.png
// module id = q0kM
// module chunks = 73